import React from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SEHomeCard } from '../../common/components/SEHomeCard';
import { SlidingAnimationPageBase } from '../../common/components/SlidingAnimationPageBase';
import { MatterDeviceIcon, OtherDeviceIcon } from '../../styles/custom-icons';

export function AddDeviceHome() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase title={t('Devices.add new device')} backURL={`../../list?direction=back`}>
      <Flex px={3} flexDirection="column">
        <SEHomeCard
          borderTopLeftRadius={'5px'}
          as={'button'}
          data-testid="add-matter-device-button"
          onClick={() => {
            navigate(`../../../matter-devices/add`);
          }}
          mb={2}
        >
          <Flex justify={'space-between'} align={'center'} cursor={'pointer'} width="100%">
            <MatterDeviceIcon w={8} h={8} />
            <Text fontSize={16} fontWeight="normal" ml={4}>
              {t('Devices.smart device')} (Matter)
            </Text>
            <ChevronRightIcon color={'customGrey.400'} w={'26px'} h={'26px'} />
          </Flex>
        </SEHomeCard>
        <SEHomeCard
          borderTopLeftRadius={'5px'}
          as={'button'}
          data-testid="add-wifi-device-button"
          onClick={() => {
            navigate(`../../../wifi-devices/add`);
          }}
          mb={2}
        >
          <Flex justify={'space-between'} align={'center'} cursor={'pointer'} width="100%">
            <OtherDeviceIcon w={8} h={8} />
            <Text fontSize={16} fontWeight="normal" ml={4}>
              {t('Devices.smart device')} (Wi-Fi)
            </Text>
            <ChevronRightIcon color={'customGrey.400'} w={'26px'} h={'26px'} />
          </Flex>
        </SEHomeCard>
      </Flex>
    </SlidingAnimationPageBase>
  );
}
